import { useMutation } from '@tanstack/react-query';

import { type Competition, type PatchCompetitionParams } from '@app/client/common/structs';
import { callUpdateCompetition } from '@app/client/resources/admin/fantasy/competitions';
import { WISHLIST_SUMMARY_CACHE } from '@app/client/resources/fantasy';

import { useGameSlug } from '../../../fantasy/fantasyWishlists';
import { useQueryInvalidation } from '../../../reactQuery';

import { formatCompetitionData } from './useCreateCompetition';

export function useUpdateCompetition(format = true) {
    const gameSlug = useGameSlug();
    const invalidateWishlists = useQueryInvalidation(WISHLIST_SUMMARY_CACHE);

    return useMutation({
        mutationFn: (postValue: PatchCompetitionParams) => {
            const value = format ? formatCompetitionData(postValue as Competition) : postValue;
            return callUpdateCompetition({ slug: gameSlug, value });
        },
        onSuccess: invalidateWishlists,
    });
}
